interface SuggestedQuestionsProps {
  questions: string[];
  onSelect: (question: string) => void;
}

export function SuggestedQuestions({ questions, onSelect }: SuggestedQuestionsProps) {
  if (questions.length === 0) return null;

  return (
    <div class="flex flex-col gap-1">
      {questions.map((q) => (
        <button
          key={q}
          onClick={() => onSelect(q)}
          class="pill-btn text-xs leading-snug px-3 py-2 rounded-lg border transition-colors cursor-pointer text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring)]"
        >
          {q}
        </button>
      ))}
    </div>
  );
}
